import historicalData from "../Assets/SideBar/historicalDataSidebar.svg";
import Home from "../Assets/SideBar/Home.svg";

import realTimeDataSideBar from "../Assets/SideBar/realTimeDataSideBar.svg";
import historicalDataActive from "../Assets/SideBar/historicalDataSidebarActive.svg";
import HomeActive from "../Assets/SideBar/HomeActive.svg";
import realTimeDataSideBarActive from "../Assets/SideBar/realTimeDataSideBarActive.svg";
import contact from "../Assets/SideBar/contact.svg";
import contactActive from "../Assets/SideBar/contactActive.svg";
// import realTimeDataSideBarActive from "../Assets/SideBar/realTimeDataSideBarActive.svg";
import CloseHamburger from "../Assets/SideBar/CloseHamburger";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import darkMode from "../Assets/SideBar/darkMode.svg";
import lightMode from "../Assets/SideBar/lightMode.svg";
import toast from "react-hot-toast";
import { Tooltip } from "react-tooltip";

import {
  setMyIndex,
  setPreviousPage,
  setTitleBar,
  setHamburger,
  setTheme,
} from "../ReduxStore/App/DashBoard/dashboardSlice";
import { useEffect, useState } from "react";
import { logout } from "../ReduxStore/App/auth.slice";
import { logoutApi } from '../api/User'

function SideBar() {
  const { isAuth, loading } = useSelector((store) => store.auth);
  const { hamburger, theme } = useSelector((store) => store.dashboard);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    temp = temp.filter((option) => !option.authRequired || (!loading && isAuth));
    setSideBarOptions(temp);
  }, [location.pathname, isAuth, loading]);

  let temp = [
    {
      logo: location.pathname === "/dashboard" ? HomeActive : Home,
      title: "Home",
      path: "/dashboard",
    },
    {
      logo:
        location.pathname === "/near-realtime-data"
          ? realTimeDataSideBarActive
          : realTimeDataSideBar,
      title: "Near Realtime",
      path: "/near-realtime-data",
      authRequired: true,
    },
    {
      logo:
        location.pathname === "/historical-data"
          ? historicalDataActive
          : historicalData,
      title: "Graphs",
      path: "/historical-data",
      authRequired: true,
    },
    {
      logo: location.pathname === "/contact" ? contactActive : contact,
      title: "Contact",
      path: "/contact",
    },
  ];
  const [sideBarOptions, setSideBarOptions] = useState([]);

  const handleSideBarOptions = (index, option) => {
    dispatch(setMyIndex(index));
    dispatch(setPreviousPage(option.path));
    navigate(option.path, { state: option.path });
    dispatch(setTitleBar(option.title));
    dispatch(setHamburger(false));
  };

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    dispatch(setTheme(newTheme));
  };

  const handleLogout = async () => {
    const res = await logoutApi();
    if (res.success) {
      dispatch(logout());
      dispatch(setMyIndex(0));
      navigate("/dashboard");
      toast.success("Successfully logged out ");
    } else {
      toast.error("Failed to log out ");
    }
  };
  return (
    <div className="lg:fixed lg:left-0 lg:top-0 lg:w-[5vw] h-screen flex flex-col justify-between bg-cardBgColor dark:bg-darkModePrimaryBgColor border-r border-gray-300 dark:border-gray-700 z-50">
      <div>
        <div
          onClick={() => dispatch(setHamburger(!hamburger))}
          className="lg:hidden h-[40px] flex justify-center mt-2  w-[40px] mx-auto hover:bg-secondaryBgColor rounded-full p-1  cursor-pointer mb-5"
        >
          <CloseHamburger theme={theme} />
        </div>
        <div>
          {sideBarOptions.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSideBarOptions(index, option)}
              className={`flex  flex-col cursor-pointer   justify-center items-center py-4 px-4 ${location.pathname === option.path
                ? "bg-primaryBgColor dark:bg-darkModePrimaryBgColor border-l-2 border-wsText dark:border-white/50 text-blackPrimaryText dark:text-darkModeBlackPrimaryText"
                : "bg-transparent border-l-2 border-transparent text-[#64748b]"
                }   text-center  text-[12px] font-bold`}
            >
              <img src={option.logo} alt={option.title} />
              <p>{hamburger ? option.title : ""}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" ">
        <div
          onClick={toggleTheme}
          className={`flex  flex-col cursor-pointer   justify-center items-center py-4 px-4   text-center  text-[12px] font-bold`}
        >
          <img src={theme === "light" ? darkMode : lightMode} alt="Mode" />
          {/* <p className={`${theme  === "light" ? 'text-blackPrimaryText': 'dark:text-darkModeBlackPrimaryText'}`}>{ theme === "light" ? "Dark Mode" : "Light Mode"}</p> */}
        </div>
      </div>
      <Tooltip id="logout-me" />
    </div>
  );
}

export default SideBar;
